import { useContext } from 'react'
import { PropertiesContext } from 'context/propertiesContext'
import styles from './propertiesList.module.css'
import dynamic from 'next/dynamic'


const ProprietyCard = dynamic(() => import('components/ProprietyCard'), {
  ssr: false
})

export default function PropertiesList() {
  const { propertiesList } = useContext(PropertiesContext)
  

  return (
    <>
      <div className={styles.container}>
        {
          propertiesList.map(propriety => {
            return (
                <div 
                  key={propriety.id}
                  className={styles.card}
                >
                  <ProprietyCard data={propriety} />
                </div>
            )
          })
        }
      </div>
    </>
  )
}